<h3 class="title-divider">{{ "VonAenderungenBetroffeneRubriken" | translate }}</h3>
<fieldset [disabled]="disabled" capAtLeastOneValidator ngModelGroup="EingabeMussMindestensEineRubrikAusgewaehltHaben">
  <cap-form-control labelKey="AmtlicheBewertung">
    <input
      (ngModelChange)="model && (model.amtlicheBewertung = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.amtlicheBewertung"
      name="amtlicheBewertung"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="Bodenbedeckung">
    <input
      (ngModelChange)="model && (model.bodenbedeckung = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.bodenbedeckung"
      id="bodenbedeckungRubrik"
      name="bodenbedeckung"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="Gebaeude">
    <input
      (ngModelChange)="model && (model.gebaeude = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.gebaeude"
      id="gebaudeRubrik"
      name="gebaeude"
      type="checkbox" />
  </cap-form-control>
  <cap-form-control labelKey="Eigentum">
    <input
      (ngModelChange)="model && (model.eigentum = $event)"
      [disabled]="disabled"
      [ngModel]="model && model.eigentum"
      name="eigentum"
      type="checkbox" />
  </cap-form-control>
</fieldset>
